import {menuScroll} from './menus'
import {fixedCourseButtons} from '../../../storage/modules/block_hero_detail/block_hero_detail';

window.addEventListener('scroll', menuScroll);
window.addEventListener('scroll', fixedCourseButtons);
